import Vue from "vue";
import ElementUI from "element-ui";
import App from "./App.vue";
import router from "./router";
import "./styles/app.css";
import "element-ui/lib/theme-chalk/index.css";
import { client } from "./services/api";
import { clearStoredUser } from "./services/auth";

Vue.config.productionTip = false;
Vue.use(ElementUI);

client.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error && error.response && error.response.status;
    if (status === 401) {
      clearStoredUser();
      if (router.currentRoute.path !== "/login") {
        const redirect = encodeURIComponent(router.currentRoute.fullPath);
        router.push(`/login?redirect=${redirect}`);
      }
    }
    return Promise.reject(error);
  }
);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");

